export default "__VITE_ASSET__DZ1PQ8Gf__"